module.exports = __webpack_public_path__ + "media/homepage/header-collage@2x-aa80b2d8.png";